import React, { Component } from 'react';
import { Link } from 'react-router';
import Header from '../components/Header';
import {
  getUserToken,
  getUserKey,
  getSelectedTeamName,
  getUserId,
  getAPIUrl,
  storeLastVisitedRoute
} from '../common/globals';
import withNotify from '../common/withNotify';
import Bugsnag from '../helpers/bugsnag';
import withUpdatedRoute from '../common/withUpdatedRoute';
import { API_VERSION } from '../common/config';

class CalendarFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFeed: 'self',
      active: 0,
      feedType: [
        {
          id: 0,
          feedName: 'Only my cases',
          value: 'self'
        },
        {
          id: 1,
          feedName: 'All cases from my team',
          value: 'team'
        }
      ],
      fileType: '',
      caller: '',
      userToken: '',
      userKey: '',
      team: '',
      mailSubject: 'OPtimize Calendar Feed URL',
      mailBody: '',
      copiedUrl: ''
    };
  }

  _onSelectedFeed = async (selectedData, index = null) => {
    try {
      const { active, isFeedType } = this.state;
      if (active === index) {
        this.setState({ active: 0, selectedFeed: '' });
      } else {
        this.setState({
          active: index,
          selectedFeed: selectedData,
          isFeedType: !isFeedType,
          fileType: selectedData.value,
          caller: await getUserId(),
          userToken: await getUserToken(),
          userKey: await getUserKey(),
          team: await getSelectedTeamName()
        }, () => this._onGetUrl());
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedTeamFeed = (position) => {
    try {
      const { active } = this.state;
      if (active === position) {
        return 'selected';
      }
      return 'self';
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopy = async () => {
    try {
      const { notify } = this.props;
      const { copiedUrl } = this.state;
      if (copiedUrl !== '') {
        const textContainer = document.getElementById('text-container').innerText;
        document.getElementById('holdtext').value = textContainer;
        const text = document.getElementById('holdtext');
        text.style.display = 'block';
        text.select();
        try {
          const status = document.execCommand('Copy');
          if (!status) {
            notify({ type: 'error', message: 'Cannot copy text' });
          } else {
            notify({ type: 'success', message: 'URL Copied', time: 3 });
          }
        } catch (err) {
        }
        text.style.display = 'none';
      } else {
        notify({ type: 'error', message: 'Cannot copy text' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetUrl = async () => {
    try {
      const {
        fileType, caller, userToken, userKey, team
      } = this.state;
      const removeSpace = team.replace(/ /g, '%20');

      const copyUri = `${await getAPIUrl()}/api/${API_VERSION}/getFeed?file_type=${fileType}&caller=${caller}&token=${userToken}&key=${userKey}&team=${removeSpace}`;

      const mailUri
        = `${await getAPIUrl()}/api/${API_VERSION}/getFeed?file_type=${fileType}&caller=${caller}&token=${userToken}&key=${userKey}&team=${encodeURIComponent(team)}`;

      this.setState({ mailBody: mailUri, copiedUrl: copyUri, team: removeSpace });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setUpdatedRoute } = this.props;
      storeLastVisitedRoute('/calendar-feed');
      setUpdatedRoute('/calendar-feed');
      this.setState({
        fileType: 'self',
        caller: await getUserId(),
        userToken: await getUserToken(),
        userKey: await getUserKey(),
        team: await getSelectedTeamName()
      }, () => this._onGetUrl());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      feedType, mailSubject, mailBody, copiedUrl
    } = this.state;
    return (
      <section className="list-section">
        <Header
          sideMenu
        />
        <section className="calendar-feed-section">
          <div className="container pt-3">
            <p>Subscribe to this feed in your calendar application to show cases on it.
              If you are adding it to your phone&apos;s calendar, use the &#34;Copy&#34;
              button to copy the feed URL to your clipboard where it can be pasted later.
              If you are adding it to another device or computer, use the &#34;Email&#34;
              button to open a new email with the feed URL in it.
            </p>

            <ul className="select-list list-unstyled cursor-pointer">
              {
                feedType.length > 0
                  ? feedType.map((data, index) => (
                    <Link onClick={() => { this._onSelectedFeed(data, index); }} key={index}>
                      <li
                        className={this._onSelectedTeamFeed(index)}
                      >
                        {data.feedName}
                      </li>
                    </Link>
                  ))
                  : <div className="text-center">No cases found</div>
              }
            </ul>

            <div className="row gx-2">
              <div className="col-6">
                <p className="invite-code" id="text-container" style={{ display: 'none' }}>{copiedUrl}</p>
                <textarea id="holdtext" style={{ display: 'none' }} readOnly />
                <button
                  className="btn btn-theme-alt w-100 btn-theme-outline-alt"
                  type="button"
                  onClick={this._onCopy}
                >Copy
                </button>
              </div>

              <div className="col-6">
                <a
                  href={`mailto:?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`}
                  target="_blank" rel="noreferrer"
                >
                  <button className="btn btn-theme-alt w-100 btn-theme-outline-alt" type="button">Email</button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withNotify(
  withUpdatedRoute(
    CalendarFeed
  )
);
